import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';

const LandingText = () => {
  return (
    <div className="position-relative py-5 overflow-hidden" style={{ background: '#000' }}>
      {/* Background waves effect using CSS gradient */}
      <div className="position-absolute w-100 h-100" style={{
        top: 0, left: 0, 
        background: 'radial-gradient(ellipse at bottom, rgba(176,66,255,0.15) 0%, rgba(0,0,0,0) 70%)',
        zIndex: 1
      }}></div>
      <Container className="position-relative py-5" style={{ zIndex: 2 }}>
        <Row className="justify-content-center text-center">
          <Col md={10} lg={8}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="mb-4 fw-bold" style={{ fontSize: "2.5rem", color: "#fff" }}>
                <span style={{ background: 'linear-gradient(90deg, #b042ff, #ff7e5f)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Promote Your Music</span> <br />
                Worldwide on All Major Platforms
              </h2>
              <p style={{ color: "#aaa", fontSize: "16px", lineHeight: "1.8", maxWidth: "700px", margin: "0 auto" }}>
                FTtunes offers seamless digital music distribution, ensuring your tracks reach major music distribution platforms worldwide. Promote your music globally and connect with new audiences through our expert services. With FTtunes, your music is everywhere it needs to be, giving you the exposure you deserve.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LandingText;
